export const PROPERTIES_PER_PAGE = 200;

export interface IPagination {
  count: number;
  limit: number; // items per page
}
